import { useEffect, useState } from 'react';

function isSamsungInternet() {
  try {
    // some browsers expose "brands" info (newer Chrome-based browsers):
    if (
      navigator.userAgentData &&
      Array.isArray(navigator.userAgentData.brands)
    ) {
      const brands = navigator.userAgentData.brands.map((b) =>
        (b.brand || '').toLowerCase()
      );
      if (brands.some((b) => b.includes('samsung'))) return true; // check for 'samsung' inside brands
    }
  } catch {}

  // fallback: look for "SamsungBrowser" in the old userAgent string:
  const ua = (navigator.userAgent || '').toLowerCase();
  return ua.includes('samsungbrowser');
} // check if the user is on Samsung Internet browser

export function useSamsungBrowserBanner() {
  const [isSamsung, setIsSamsung] = useState(false); // true if Samsung Internet
  const [dismissed, setDismissed] = useState(false); // true if user closed the banner

  useEffect(() => {
    setDismissed(localStorage.getItem('samsungBrowserBannerDismissed') === '1'); // check if the banner was dismissed earlier (saved in localStorage)
  }, []);

  useEffect(() => {
    setIsSamsung(isSamsungInternet());
  }, []); // run once after the component mounts to detect Samsung Internet; the detection can't throw in a browser (its one risky read has its own catch), so the try/catch that was around it went (user decision, Oct 2026)

  const dismiss = () => {
    localStorage.setItem('samsungBrowserBannerDismissed', '1'); // save dismissal so the banner won’t reappear on reload
    setDismissed(true);
  };

  const showSamsungBanner = isSamsung && !dismissed; // show the banner only if: Samsung Internet is detected AND user hasn’t dismissed it

  return { showSamsungBanner, isSamsung, dismissed, dismiss };
} // react hook: decide whether to show a warning banner
